import React, { useEffect, useState } from "react";
import { Tabs, AppBar, Tab, Box } from "@material-ui/core";
import _ from "lodash";
import PersonalInfo from "./components/personalInfo";
import Resume from "./components/resume";
import Video from "./components/video";
import Sheba from "./components/sheba";
import useGetProfileInfoHook from "../../../hooks/useGetProfileInfoHook";

import "./ProfileHome.scss";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export const ProfileHome = (props) => {
  const { info, data, resume } = useGetProfileInfoHook();
  const hash = props.location?.hash.replace("#", "");

  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setTabValue(Number(hash) || 0);
  }, [hash]);

  if (_.isNil(info)) {
    return null;
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <section className="container">
      {info.role === "Teacher" ? (
        <>
          <AppBar position="static">
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="اطلاعات فردی" {...a11yProps(0)} />
              <Tab label="رزومه" {...a11yProps(1)} />
              <Tab label="ویدئو" {...a11yProps(2)} />
              <Tab label="اطلاعات بانکی" {...a11yProps(3)} />
            </Tabs>
          </AppBar>
          <TabPanel value={tabValue} index={0}>
            {!_.isNil(data) && <PersonalInfo data={data} info={info} />}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {!_.isNil(resume) && <Resume resume={resume} />}
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            {!_.isNil(data) && <Video video={data.IntroductionVideo} />}
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            {!_.isNil(data) && <Sheba ShebaNumber={data.ShebaNumber} />}
          </TabPanel>
        </>
      ) : !_.isNil(data) ? (
        <PersonalInfo data={data} info={info} />
      ) : null}
    </section>
  );
};
export default ProfileHome;
